<div class='w-full h-[92vh] flex'>
    <!-- LATERAL MENU -->
    <app-split-view-side-head class="w-[5.5rem] h-full flex flex-col" (click)="drawer.toggle()" [type]="'intern'">
    </app-split-view-side-head>
    <mat-drawer-container class="transition-box" [ngClass]="{'flex-grow': (fullWidth && drawer.opened)}">
        <!-- DRAWER -->
        <mat-drawer #drawer class="min-w-[35vw] w-full" mode="side" [opened]="false">
            <section class="flex flex-col">
                <!-- INFOS  -->
                <app-proofreading-info [type]="'intern'"></app-proofreading-info>
                <!-- STATE MACHINE -->
                <app-state-machine-intern *ngIf="(isOperator() || isCPP())">
                </app-state-machine-intern>
                <!-- MEMBERS -->
                <app-members-assessments [proofreading]="proofreading" [readonly]="readOnlyMembers" *ngIf="isCPP()"></app-members-assessments>
                <!-- PRODUCTION TEXTS -->
                <app-production-texts split-view *ngIf="proofreading && has_textes_flow" [type]="'intern'" [readOnly]="readOnlyText" [project]="proofreading.project" [productionTexts]="proofreading.texts"></app-production-texts>
            </section>
        </mat-drawer>
    </mat-drawer-container>
    <!-- DRAWER BUTTON -->
    <div class="w-[3rem] h-full flex flex-col border-r-2 bg-tw-lightgrey">
        <div class="flex justify-center items-center flex-grow" (click)="drawer.toggle()">
            <button type="button" mat-icon-button>
                <mat-icon>{{ drawer.opened? 'chevron_left' : 'chevron_right' }}</mat-icon>
            </button>
        </div>
        <div class="h-[10%] border-t-2 border-dashed flex justify-center items-center" (click)="toggleTextFull = !toggleTextFull">
            <button [disabled]="!drawer.opened" type="button" mat-icon-button>
                <mat-icon>{{ toggleTextFull? 'first_page' : 'last_page' }}</mat-icon>
            </button>
        </div>
    </div>
    <!-- VIEWER  -->
    <div class='h-full flex-grow' [ngClass]="{'hidden':loading || (fullWidth && drawer.opened) }">
        <button class="cancel-fullscreen w-full " (click)="cancelFullScreen()">
            <span class="flex gap-2 bg-tw-text-disabled text-tw-text-light items-center p-1">
                <mat-icon>fit_screen</mat-icon>
                <span>{{ 'CANCEL_FULLSCREEN' | translate }}</span>
            </span>
        </button>
        <iframe class="w-full h-full" id='internViewLink' loading='lazy'>
        </iframe>
    </div>
</div>
<app-loader *ngIf="loading" class="absolute w-screen h-screen" [loading]="loading"> </app-loader>